import { REQUEST_BILL_PAYMENT, REQUEST_BILL_PAYMENT_FAILURE, REQUEST_BILL_PAYMENT_SUCCESS } from "../../constant/DashboardConstant";

const initialState = {
  billPayment: {
    data: [],
  },
};

export const billPaymentReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case REQUEST_BILL_PAYMENT:
      return {
        ...state,
        billPayment: {
          data: [],
          status: 'fetching',
          isLoading: true,
        },
      };
    case REQUEST_BILL_PAYMENT_SUCCESS:
      return {
        ...state,
        billPayment: {
          data: payload,
          status: 'ready',
          isLoading: false,
        },
      };
    case REQUEST_BILL_PAYMENT_FAILURE:
      return {
        ...state,
        billPayment: {
          data: [],
          status: 'failure',
          isLoading: false,
        },
      };
    default:
      return state;
  }
}
